"use client"

import { useState, useEffect } from "react"
import { Link, useLocation, useNavigate } from "react-router-dom"
import "./Header.css"

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const location = useLocation()
  const navigate = useNavigate()

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  // Handle scrolling to hash on page load/navigation
  useEffect(() => {
    if (location.pathname === "/" && location.hash) {
      const sectionId = location.hash.replace("#", "")
      const element = document.getElementById(sectionId)
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth" })
        }, 100)
      }
    }
  }, [location])

  const handleHomeClick = (e) => {
    setIsMenuOpen(false)
    if (location.pathname === "/") {
      e.preventDefault()
      window.scrollTo({ top: 0, behavior: "smooth" })
      if (window.location.hash) {
        window.history.replaceState(null, "", "/")
      }
    }
  }

  const handleSectionClick = (e, sectionId) => {
    e.preventDefault()
    setIsMenuOpen(false)

    if (location.pathname === "/") {
      // Already on homepage, just scroll
      const element = document.getElementById(sectionId)
      if (element) {
        element.scrollIntoView({ behavior: "smooth" })
      }
    } else {
      // Navigate to homepage with hash
      navigate(`/#${sectionId}`)
    }
  }

  return (
    <header className="header">
      <div className="header-container">
        <div className="logo">
          <Link to="/">
            <div className="logo-icon">GP</div>
            <span className="logo-text">Goosnargh Pharmacy</span>
          </Link>
        </div>

        <nav className={`nav-menu ${isMenuOpen ? "active" : ""}`}>
          <Link to="/" className="nav-link" onClick={handleHomeClick}>
            Home
          </Link>
          <a href="/#services" className="nav-link" onClick={(e) => handleSectionClick(e, "services")}>
            Services
          </a>
          <a href="/#about" className="nav-link" onClick={(e) => handleSectionClick(e, "about")}>
            About
          </a>
          <a href="/#contact" className="nav-link" onClick={(e) => handleSectionClick(e, "contact")}>
            Contact
          </a>
          <Link to="/nominate" className="nav-link highlight" onClick={() => setIsMenuOpen(false)}>
            Nominate Us
          </Link>
        </nav>

        <div className="contact-button">
          <Link to="/services" className="button primary" onClick={() => setIsMenuOpen(false)}>
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <rect width="18" height="18" x="3" y="4" rx="2" ry="2" />
              <line x1="16" x2="16" y1="2" y2="6" />
              <line x1="8" x2="8" y1="2" y2="6" />
              <line x1="3" x2="21" y1="10" y2="10" />
            </svg>
            Book a Service
          </Link>
        </div>

        <div className="mobile-menu-toggle" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </header>
  )
}

export default Header
